export default {
	header: 'Seznam kampaní',
	campaignName: 'Název',
	campaignState: 'Stav kampaně',
	channel: 'Kanál',
	startDate: 'Platnost od',
	endDate: 'Platnost do',
	newCampaign: 'Nová kampaň',
	communicationName: 'Název komunikace',
	campaignType: 'Typ kampaně',
	campaignStartDate: 'Začátek kampaně',
	campaignEndDate: 'Konec kampaně',
	newCampaignName: 'Název kampaně',
	lightboxTitleDeleteCampaign: 'Opravdu si přejete vymazat tuto kampaň?',
};
